import { miscUiState } from '../globalState'
import { options } from '../optionsStorage'
import { progressNotificationsProxy, setNotificationProgress } from '../react/NotificationProvider'

const loadingChunksProgress = () => {
  if (!appViewer) return
  let gameStopped = false

  const checkStartProgress = () => {
    if (!bot.entity || !options.displayLoadingMessages) return

    let lastChunksLoaded = {
      count: 0,
      time: 0,
    }
    const update = () => {
      if (!appViewer) return
      const chunksTotal = appViewer.nonReactiveState.world.chunksTotalNumber
      if (chunksTotal === 0) return

      const currentChunksLoaded = appViewer.rendererState.world.chunksLoaded.size

      // Always let the map fill calmly to 100% before it fades — never vanish
      // mid-progress, regardless of how loading actually ended.
      const finishProgress = () => {
        clearInterval(intervalId)
        setNotificationProgress('loadingChunks', { current: chunksTotal, total: chunksTotal })
        setTimeout(() => setNotificationProgress('loadingChunks', { delete: true }), 900)
      }

      if (gameStopped) {
        setNotificationProgress('loadingChunks', { delete: true })
        clearInterval(intervalId)
        return
      }

      if (appViewer.rendererState.world.allChunksLoaded) {
        finishProgress()
        return
      }

      if (currentChunksLoaded === lastChunksLoaded.count && lastChunksLoaded.count) {
        if (Date.now() - lastChunksLoaded.time > 1000 * 5) {
          finishProgress() // stalled — still resolve to 100% calmly
          return
        }
      } else {
        lastChunksLoaded = {
          count: currentChunksLoaded,
          time: Date.now(),
        }
      }

      setNotificationProgress('loadingChunks', {
        message: 'Загрузка чанков мира',
        current: currentChunksLoaded,
        total: chunksTotal,
        priority: 1,
      })
    }

    const intervalId = setInterval(update, 500)
    update()
  }

  const startInventoryTexturesProgress = () => {
    if (!miscUiState.gameLoaded) return
    if (appViewer.resourcesManager.currentConfig?.noInventoryGui) return
    setNotificationProgress('inventoryTextures', {
      message: 'Обработка текстур интерфейса',
    })
  }

  customEvents.on('gameLoaded', () => {
    checkStartProgress()
    if (!appViewer.resourcesManager.currentConfig?.noInventoryGui && !appViewer.resourcesManager.currentResources?.guiAtlas) {
      startInventoryTexturesProgress()
    }

    bot._client.on('login', () => {
      checkStartProgress()
    })
    bot._client.on('respawn', () => {
      checkStartProgress()
    })

    bot.on('end', () => {
      gameStopped = true
      // remove all progress notifications
      progressNotificationsProxy.loaders = []
    })
  })

  appViewer.resourcesManager.on('assetsInventoryStarted', () => {
    startInventoryTexturesProgress()
  })
  appViewer.resourcesManager.on('assetsInventoryReady', () => {
    setNotificationProgress('inventoryTextures', {
      delete: true,
    })
  })
}

setTimeout(() => {
  loadingChunksProgress()
})
